import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { loggerFunc } from 'utils/logger';
import PopupTypes from 'utils/popupTypes';
import { useNavigate, useLocation } from 'react-router-dom';
import * as SessionActions from 'actions/sessionActions';
import PopupModal from 'components/PopupModal/PopupModal';
import Spinner from 'components/Spinner';
import Toast from 'components/Toast/Toast';
import LoyaltyRewardsDesktop from 'assets/images/loyaltyRewards/popup/desktop.gif';
import LoyaltyRewardsMobile from 'assets/images/loyaltyRewards/popup/mobile.gif'
import { RENEWAL, RAC_LOYALTY_REWARDS, VULNERABLE_CUSTOMERS } from 'constants/routeConstants';
import { SourceCodes } from 'constants/enums';
import { eFulfilmentErrorMessages } from 'constants/cms/messageConstants';
import { useApplicationState } from 'hooks/applicationState-Context';
import { useUserJourney } from 'hooks/userJourney-Context';
import TescoPanel from 'panels/TescoPanel';
import Efulfilment from 'modals/Efulfilment';
import { GetContent, GetTileContent } from 'services/ContentService';
import { GetRenewalPopup, GetRenewalEligibility, GetTescoLoginJID, GetPayfailInformation } from 'services/MyRacService';
import { ResponseCode } from 'services/models/httpResponse';
import { getMessage } from 'services/MessageService';
import trackEvent from 'services/AnalyticsService';
import useUserProducts from 'utils/useUserProducts';
import useViewport from 'utils/useViewportHelper';
import modalTypes from 'utils/modalTypesEnum';
import TileSets from 'utils/tileSets.enum';
import AppMerchandising, { showAppMerchandisingPopup } from 'views/MyRac/MembershipOverview/Popups/AppMerchandising/AppMerchandising';
import Payfail from '../Popups/PayfailModal/PayfailModal';
import AlertsManager from './Alerts/AlertsManager';
import WelcomeTile from '../../../Widgets/WelcomeTile';
import AbstractGrid from './AbstractGrid';
import DefaultAlert from './Alerts/DefaultAlert';
import './GridLayout.scss';

const logger = loggerFunc('GridLayout');

// Last 29 days before renewal, inclusive of the renewal date itself
const TESCO_CONTINUOUS_WINDOW_DAYS = 29;

export const GridLayout = (props) => {
  const {
    customer: { custInfo },
    policy: { policyInfo },
    tiles: { membershipOverview },
    updateEfulfilmentShown,
    updateTescoPopupShown,
    updateRewardsPopupShown,
    updateRenewBannerShown,
    updatePayfailPopupShown,
    storeRenewBannerImgUrl,
    session,
  } = props;

  const { appState, setPageLoading } = useApplicationState();
  const { userJourneyState } = useUserJourney();
  const location = useLocation();
  const { isIMAccount } = useUserProducts();

  const [pageModel, setPageModel] = useState(null);
  const [eFulfilmentError, setEFulfilmentError] = useState(false);
  const [renewNowBanner, setRenewNowBanner] = useState(false);
  const [renewNowBannerImage, setRenewNowBannerImage] = useState();
  const [tescoRenew, setTescoRenew] = useState(false);
  const [tescoContinuous, setTescoContinuous] = useState(false);
  const [racLoyaltyRewards, setRacLoyaltyRewards] = useState(false);
  const [claimRewardsModal, setClaimRewardsModal] = useState(false);
  const [payfailEligibility, setPayfailEligibility] = useState();
  const [tescoJID, setTescoJID] = useState();
  const [renewNowStatus, setRenewNowStatus] = useState();
  const [toast, setToast] = useState(location?.state?.toast || null);
  const [popupEligibilityFetched, setPopupEligibilityFetched] = useState(false);
  const [popupToShow, setPopupToShow] = useState(PopupTypes.NONE);
  const [popupResolved, setPopupResolved] = useState(false);

  const navigate = useNavigate();

  const MAX_COLS = 4;
  const notificationLinks = [];

  // Captures a change to the mobile layout and causes a new render with subsequent re-request of the grid data
  const currentMobileState = useViewport().isBootstrapSm;

  // PopupModal override styles for 'Renew Now' banner as part of Renewals promotion
  const renewBannerStyle = {
    backgroundImage: `url(${renewNowBannerImage})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    height: currentMobileState ? '97vw' : '570px',
    marginTop: currentMobileState ? '70px' : '100px',
  };
  // Area map of where clickable
  const renewBannerButton = {
    margin: currentMobileState ? '60% auto' : '75% auto',
    height: '5rem',
    width: '70%',
  };

  // Welcome content for the welcome tile is independent of the Grid tile data
  const welcomeContent = async () => GetContent('membershipoverviewpage', 'Membership Overview Desktop').then((response) => response).catch((err) => logger.debug(err));

  // Determine popup to be shown based on eligibility
  const fetchPopupEligibility = async () => {
    try {
      const response = await GetRenewalEligibility(custInfo.Id);
      if (response.payload) {
        const { isEligibleForRenewal, hasRacLoyaltyRewards } = response.payload;
        // Tesco members are identified by referral link or by their policy source code
        const isTescoMember = session?.isTescoLogin || policyInfo?.sourceCode === SourceCodes.RWAFTS2;
        // Continuous members see different copy in the panel: auto-renewing cover they cannot renew themselves, close to the date
        const isTescoContinuous = !isEligibleForRenewal
          && !!policyInfo?.AutoRenew?.IsAutoRenew
          && policyInfo?.DaysToRenewal >= 0
          && policyInfo?.DaysToRenewal <= TESCO_CONTINUOUS_WINDOW_DAYS;

        // Eligible members can renew online, continuous members cannot but can still pay with vouchers
        const showTescoPopup = isTescoMember && (isEligibleForRenewal || isTescoContinuous);

        if (showTescoPopup) {
          GetTescoLoginJID(custInfo.Id, session.memberNo).then((res) => {
            setTescoJID(res?.payload);
          }).catch((err) => logger.error(err));
          setTescoRenew(true);
          setTescoContinuous(isTescoContinuous);
        } else if (isEligibleForRenewal) {
          // Renewal popup
          GetRenewalPopup(custInfo.Id).then(async (res) => {
            if (res?.payload) {
              const { url, fileName } = res.payload;
              // Add image url to page state
              setRenewNowBannerImage(url);
              // Store image url in session state for use on other pages
              storeRenewBannerImgUrl(url);
              // Image defines cover status therefore slice file extention from filename and use to set value in state
              const coverStatus = fileName && (fileName).slice(0, -4) === 'RenewNowPopup' ? 'renew' : 'expired';
              // Fallback in case filename uploaded to cms fails to match pattern above
              setRenewNowStatus(coverStatus ?? 'renew');
              // Popup not to be shown if member was redirected via deep link or has already visited the Renewal page
              const visitedRenewalPage = userJourneyState?.pageHistory.includes(RENEWAL);
              if (!visitedRenewalPage) {
                setRenewNowBanner(true);
                if (coverStatus) {
                  trackEvent(`ukbc.${coverStatus}popupdisplayed`);
                }
              }
            }
          }).catch((err) => logger.debug(err));
        }
        // RAC Loyalty Rewards
        if (hasRacLoyaltyRewards && !session?.isTescoLogin) {
          if (!isEligibleForRenewal) {
            setRacLoyaltyRewards(true);
            setClaimRewardsModal(true);
          }
        }

        const payfailResponse = await GetPayfailInformation();

        if (payfailResponse?.payload) {
          setPayfailEligibility(payfailResponse.payload);
        }

        setPopupEligibilityFetched(true);
      }
    } catch (err) {
      logger.debug(err);
    }
  };

  useEffect(() => {
    if (appState?.loading?.status && custInfo && custInfo?.Id) {
      // Grid tiles
      GetTileContent(custInfo.Id, session?.memberNo, TileSets?.membershipOverview, currentMobileState).then(() => {
        welcomeContent().then(async (result) => {
          if (result?.responseCode === ResponseCode?.SUCCESS) {
            // Popup modal
            const popup = await fetchPopupEligibility();
            // Page data
            const pageData = await setPageModel(result?.payload);
            // Loading state
            Promise.all([popup, pageData])
              .then(() => setPageLoading(false, null));
          }
        }).catch((err) => logger.debug(err));
      });
    }
  }, [custInfo?.Id, session?.memberNo, appState?.loading?.status, custInfo, currentMobileState]);

  const toggleShowEFulfilment = (event) => {
    event.preventDefault();
    updateEfulfilmentShown(true);
  };

  const toggleFulfilmentError = () => {
    setEFulfilmentError(!eFulfilmentError);
    updateEfulfilmentShown(true);
  };

  const toggleTescoPopup = () => {
    // Close modal window
    setTescoRenew(false);
    // Store action in session so that popup is not displayed again until next user session
    updateTescoPopupShown(true);
  };

  const toggleRacLoyaltyRewards = (toggle) => {
    // Close modal window
    setClaimRewardsModal(false);
    // Store action in session so that popup is not displayed again until next user session
    updateRewardsPopupShown(true);
    if (!toggle) {
      // Boolean flag used to falsify toggle and redirect user on action button click
      navigate(RAC_LOYALTY_REWARDS);
    }
  };

  const toggleRenewNowBanner = () => {
    setRenewNowBanner(!renewNowBanner);
    updateRenewBannerShown(true);
    trackEvent(`ukbc.${renewNowStatus}popupclosed`);
  };

  useEffect(() => {
    if (!session && !popupEligibilityFetched && popupResolved) return;

    let popupType = PopupTypes.NONE;

    // Popup priority
    if (!session?.payfailPopupShown && session?.showPayfailAlert) {
      popupType = PopupTypes.PAYFAIL;
      setPopupResolved(true);
    } else if (tescoRenew && !renewNowBanner && !session?.tescoPopupShown) {
      popupType = PopupTypes.TESCO;
      setPopupResolved(true);
    } else if (claimRewardsModal && !session?.racLoyaltyRewardShown && !tescoRenew && !renewNowBanner) {
      popupType = PopupTypes.RAC_LOYALTY_REWARDS;
      setPopupResolved(true);
    } else if (renewNowBanner && !session?.renewBannerShown && !tescoRenew) {
      popupType = PopupTypes.RENEW_NOW;
      setPopupResolved(true);
    } else if (eFulfilmentError) {
      popupType = PopupTypes.EFULFILMENT;
      setPopupResolved(true);
    } else if (popupEligibilityFetched && !popupResolved && showAppMerchandisingPopup()) {
      popupType = PopupTypes.APP_MERCHANDISE;
    }

    setPopupToShow(popupType);
  }, [
    popupEligibilityFetched,
    popupResolved,
    session,
    tescoRenew,
    renewNowBanner,
    claimRewardsModal,
    eFulfilmentError,
  ]);

  return (
    <>
      { pageModel && custInfo && membershipOverview ? (
        <>
          <WelcomeTile pageModel={pageModel} notifications={notificationLinks} />
          {toast && <Toast msg={toast.msg} type={toast.type} closeHandler={() => setToast(null)} />}
          {/* All alerts on the homepage should go here */}
          <AlertsManager racLoyaltyRewards={racLoyaltyRewards} setToastMessage={setToast} />
          {/* Grid Layout */}
          <div className="grid-wrapper" data-testid="GridLayoutContainer">
            <AbstractGrid
              columns={MAX_COLS}
              tiles={membershipOverview}
              alert={isIMAccount && (
                <DefaultAlert
                  heading="Help & support"
                  message="Let us know if you need additional support."
                  buttonText="Add details"
                  linkRef={VULNERABLE_CUSTOMERS}
                  eventTag="MyRAC_VulnerableCustomers_Banner"
                  fireTrackEventOnLoad={false}
                  isButton
                />
              )}
            />
          </div>
        </>
      ) : null }
      {popupToShow === PopupTypes.TESCO && (
        <PopupModal
          resultTitle="Tesco Clubcard"
          form={tescoJID ? <TescoPanel jid={tescoJID} isTescoContinuous={tescoContinuous} /> : <Spinner defaultSpinner />}
          action={() => toggleTescoPopup()}
          headerOverrideStyle={{ textAlign: 'center' }}
          innerCloseButton
        />
      )}
      {
        pageModel && session?.efulFilmentShown && !custInfo?.WebRegistered
        && !custInfo?.isPaperLess && !eFulfilmentError
        && <Efulfilment toggleShowModal={toggleShowEFulfilment} toggleHideEFulfilmentModal={toggleFulfilmentError} />
      }
      {popupToShow === PopupTypes.EFULFILMENT && (
        <PopupModal
          modalOk="Ok"
          resultTitle={getMessage(eFulfilmentErrorMessages.ERROR_HEADER)}
          resultText={getMessage(eFulfilmentErrorMessages.ERROR_SUBTEXT)}
          alignBodyCenter
          alignHeaderCenter
          displayDialogAtTopQuarter
          action={toggleFulfilmentError}
          innerCloseButton
        />
      )}
      {popupToShow === PopupTypes.RENEW_NOW && (
        <PopupModal
          action={toggleRenewNowBanner}
          bannerCloseButton
          backgroundOverrideStyle={renewBannerStyle}
          backgroundButtonMap={renewBannerButton}
          backgroundButtonAlt="Renew now"
          eventTag={`ukbc.${renewNowStatus}popupclicked`}
          linkRef={RENEWAL}
        />
      )}
      {popupToShow === PopupTypes.RAC_LOYALTY_REWARDS && (
        <PopupModal
          modalType={currentMobileState ? modalTypes.infoModal : modalTypes.wideModal}
          yesButton="Choose my upgrade"
          action={() => toggleRacLoyaltyRewards(false)}
          cancelTextButton="Close"
          cancelAction={() => toggleRacLoyaltyRewards(true)}
          image={currentMobileState ? LoyaltyRewardsMobile : LoyaltyRewardsDesktop}
          resultText={(<p>As a thanks for being with the RAC, we&apos;re giving you a choice of upgrades to add to your cover. FREE till your next renewal.<br /><small>T&Cs apply.</small></p>)}
          alignBodyCenter
          innerCloseButton
          eventTag="MyRAC_RLR_PopUp_Clicked"
          popupDisplayedEvent="MyRAC_RLR_PopUp_Displayed"
        />
      )}
      {popupToShow === PopupTypes.PAYFAIL && (
        <Payfail payfailEligibility={payfailEligibility} updatePayfailPopupShown={updatePayfailPopupShown} />
      )}
      {popupToShow === PopupTypes.APP_MERCHANDISE && (
        <AppMerchandising />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  policy: state.policy,
  customer: state.customer,
  session: state.session,
  featureFlags: state.featureToggle,
  tiles: state.content.tiles,
});

const mapDispatchToProps = (dispatch) => ({
  updateEfulfilmentShown: (efulfilmentShown) => {
    dispatch(SessionActions.setEfulfilmentShown(efulfilmentShown));
  },
  updateTescoPopupShown: (tescoPopupShown) => {
    dispatch(SessionActions.setTescoPopupShown(tescoPopupShown));
  },
  updateRewardsPopupShown: (racLoyaltyRewardShown) => {
    dispatch(SessionActions.setRacLoyaltyRewardShown(racLoyaltyRewardShown));
  },
  updateRenewBannerShown: (renewBannerShown) => {
    dispatch(SessionActions.setRenewBannerShown(renewBannerShown));
  },
  updatePayfailPopupShown: (bool) => {
    dispatch(SessionActions.setPayfailPopupShown(bool));
  },
  storeRenewBannerImgUrl: (renewBannerImgUrl) => {
    dispatch(SessionActions.setRenewBannerImgUrl(renewBannerImgUrl));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GridLayout);
